// extracted by mini-css-extract-plugin
module.exports = {"layoutWrapperMain":"BlogPage_layoutWrapperMain__LZejt","blogItemsWrapper":"BlogPage_blogItemsWrapper__2eJJ0","addNewBtn":"BlogPage_addNewBtn__2IQQ2"};